import React, { useState, useEffect, useRef } from 'react'
import { BrowserRouter, Routes, Route, NavLink } from 'react-router-dom'
import * as S from "./header_style.jsx"
import Logo from "../imagens/Logo FA.bmp"
import Main from "../Main/mainHome.jsx"
import CustoBeneficio from "../Main/custo_beneficio.jsx"
import Portfolio from "../Main/portfolio.jsx"
import InformacoesTecnicas from "../Main/informacoes_tecnicas.jsx"

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false)
  const menuRef = useRef(null)

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  };

  useEffect(() => {
    if (menuRef.current) {
      if (isMenuOpen) {
        menuRef.current.style.maxHeight = menuRef.current.scrollHeight + 'px'
      } else {
        menuRef.current.style.maxHeight = null
      }
    }
  }, [isMenuOpen])

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <>
      <BrowserRouter>
        <S.Header isScrolled={isScrolled}>
        <NavLink to="/"><S.Img src={Logo} alt="logo" /></NavLink>
          <S.Nav>
            <S.Ul>
              <S.Li><NavLink to="/">Home</NavLink></S.Li>
              <S.Li><NavLink to="/custo-beneficio">Custo/Benefício</NavLink></S.Li>
              <S.Li><NavLink to="/portfolio">Portfolio</NavLink></S.Li>
              <S.Li><NavLink to="/informacoes-tecnicas">Produtos</NavLink></S.Li>
            </S.Ul>
          </S.Nav>
          <S.A href="https://wa.me/5521988838985" target="_blank" rel="noreferrer">
            <S.Button>Contato</S.Button>
            </S.A>
          <S.DivMobile>
            <S.ButtonMobile id="btn" onClick={() => {toggleMenu()}}>{isMenuOpen === true ? "✕" : "☰"}</S.ButtonMobile>
            <S.NavMobile id="menuMobile" ref={menuRef}>
              <S.UlMobile>
                <S.LiMobile><S.aMobile><NavLink to="/">Home</NavLink></S.aMobile></S.LiMobile>
                <hr></hr>
                <S.LiMobile><S.aMobile><NavLink to="/custo-beneficio">Custo/Benefício</NavLink></S.aMobile></S.LiMobile>
                <hr></hr>
                <S.LiMobile><S.aMobile><NavLink to="/portfolio">Portfolio</NavLink></S.aMobile></S.LiMobile>
                <hr></hr>
                <S.LiMobile><S.aMobile><NavLink to="/informacoes-tecnicas">Produtos</NavLink></S.aMobile></S.LiMobile>
              </S.UlMobile>
            </S.NavMobile>
          </S.DivMobile>
        </S.Header>
        <Routes>
          <Route path="/" element={<Main />} />
          <Route path="/custo-beneficio" element={<CustoBeneficio />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/informacoes-tecnicas" element={<InformacoesTecnicas />} />
        </Routes>
      </BrowserRouter>
    </>
  )
}